import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { HomePageLoaderData } from '~/routes';

import AuthorsWidget from './AuthorsWidget';
import CategoriesWidget from './CategoriesWidget';
import NewslettersWidget from './NewslettersWidget';
import RecommendationsWidget from './RecommendationsWidget';
import SignupWidget from './SignupWidget';
import SocialWidget from './SocialWidget';

interface Props {
  isNewWebBuilder?: boolean;
}

const WidgetsSection = ({ isNewWebBuilder }: Props) => {
  const { homePage, publication } = useTypedLoaderData<HomePageLoaderData>();
  const textColor = homePage?.general_section.theme.text_color;
  const fontFamily = homePage?.general_section.theme.font;
  const widgets = homePage?.widgets_section.widgets_enabled;
  const signupBgColor = homePage?.main_section.signup_widget.bg_color;
  const signupTextColor = homePage?.main_section.signup_widget.text_color;

  const widgetsOptions: any = {
    social: <SocialWidget publication={publication} textColor={textColor} isNewWebBuilder={isNewWebBuilder} />,
    signup: (
      <SignupWidget
        publication={publication}
        bgColor={signupBgColor}
        textColor={signupTextColor}
        fontFamily={fontFamily}
        placeholderText={homePage?.main_section.signup_widget.placeholder_text}
        ctaText={homePage?.main_section.signup_widget.cta_text}
        isNewWebBuilder={isNewWebBuilder}
      />
    ),
    recommendations: (
      <RecommendationsWidget textColor={textColor} fontFamily={fontFamily} isNewWebBuilder={isNewWebBuilder} />
    ),
    newsletters: <NewslettersWidget textColor={textColor} fontFamily={fontFamily} isNewWebBuilder={isNewWebBuilder} />,
    categories: (
      <CategoriesWidget
        publication={publication}
        textColor={textColor}
        fontFamily={fontFamily}
        isNewWebBuilder={isNewWebBuilder}
      />
    ),
    authors: <AuthorsWidget textColor={textColor} fontFamily={fontFamily} isNewWebBuilder={isNewWebBuilder} />,
  };

  return (
    <div className="space-y-4">
      {widgets.map((widget: string) => {
        return <div key={widget}>{widgetsOptions[widget]}</div>;
      })}
    </div>
  );
};

export default WidgetsSection;
